import React from 'react';
import '../styles/Footer2.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faLinkedinIn, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faDownload } from '@fortawesome/free-solid-svg-icons';

function Footer2(props) {
    const phoneNumber = '919811183646'; //WhatsApp phone number
    const pdfDownloadLink = "https://drive.google.com/uc?export=download&id=1tUi3vVky7CqBnIiAU_zmExlv1Xc4lyZo"; // Google Drive direct download link

    return (
        <div className='copyright'>
            <div style={{ padding: '10px' }}>
                Copyright © 2024-25 to www.newageacoustics.com | All Rights Reserved
            </div>
            <div className='icons'>
                <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
                    <FontAwesomeIcon style={{ color: 'white', fontSize: '18px', marginRight: '15px' }} icon={faFacebookF} />
                </a>
                <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer">
                    <FontAwesomeIcon style={{ color: 'white', fontSize: '20px', marginRight: '15px' }} icon={faLinkedinIn} />
                </a>
                <a href="mailto:newageacoustics@gmail.com" target="_blank" rel="noopener noreferrer">
                    <FontAwesomeIcon style={{ color: 'white', fontSize: '20px', marginRight: '15px' }} icon={faEnvelope} />
                </a>
                <a href={`https://wa.me/${phoneNumber}`} target="_blank" rel="noopener noreferrer">
                    <FontAwesomeIcon style={{ color: 'white', fontSize: '20px', marginRight: '15px' }} icon={faWhatsapp} />
                </a>
                {/* Download Icon */}
                <a href={pdfDownloadLink} download="Absound Overseas e-catalogue.pdf" target="_blank" rel="noopener noreferrer">
                    <FontAwesomeIcon style={{ color: 'white', fontSize: '20px' }} icon={faDownload} />
                </a>
            </div>
        </div>
    );
}

export default Footer2;
